import React, { useState, useEffect, useRef } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  // Input,
  Button,
  Table,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import { CSVExport } from "react-bootstrap-table2-toolkit"
//import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import { withRouter } from "react-router-dom"
import Modal from "react-bootstrap/Modal"
import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import * as equipmentAction from "../../store/RXF1aXBtZW50TWFwcGluZw/actions"
import { isEmpty } from "lodash"
import SimpleReactValidator from "simple-react-validator"
import ButtonSpinner from "components/ButtonSpinner"
import { toast, ToastContainer } from "react-toastify"

const EquipmentMapping = (props) => {
  const { SearchBar } = Search
  const { dispatch, searchBtnStyle } = props
  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()

  //Export downlaod options
  const { ExportCSVButton } = CSVExport

  const update = useSelector((specificstate) => specificstate.EquipmentMapping)
  console.log("update is", update)
  useEffect(() => {
    dispatch(equipmentAction.loadRecordsMetaData())
    dispatch(equipmentAction.loadRecords())
    // dispatch(equipmentAction.loadEquipmentMaster())
  }, [])
  const { recordsMetaData = {}, records = [], equipment_master = [] } = update

  const title = "Equipment Mapping"

  console.log(recordsMetaData, "recordMetaData")
  //dummy data table
  const [equipmentModal, setEquipmentModal] = useState(false)
  const [fullscreen, setFullscreen] = useState(false)
  const [editequipment, setEditEquipment] = useState(false)
  // const [deletemodal, setDeletemodal] = useState(false)

  const handleModal = () => {
    setEquipmentModal(false)
  }

  //Handle Change
  const [equipmentMaster, setEquipmentMaster] = useState([])
  const [equipmentType, setEquipmentType] = useState([])
  const [equipmentBrand, setEquipmentBrand] = useState([])
  const [equipmentProduct, setEquipmentProduct] = useState([])
  const [btnLoader, setBtnLoader] = useState(false)

  const handleApply = () => {
    var searchMaster =
      equipmentMaster && equipmentMaster.value ? equipmentMaster.value : ""
    var searchType =
      equipmentType && equipmentType.value ? equipmentType.value : ""
    var searchBrand =
      equipmentBrand && equipmentBrand.value ? equipmentBrand.value : ""
    var searchProduct =
      equipmentProduct && equipmentProduct.value ? equipmentProduct.value : ""

    var searchFilter = {}
    if (searchMaster) {
      searchFilter.mode = searchMaster
    }
    if (searchType) {
      searchFilter.equipmentTypeId = searchType
    }
    if (searchBrand) {
      searchFilter.equipmentBrandId = searchBrand
    }
    if (searchProduct) {
      searchFilter.productVersionId = searchProduct
    }

    dispatch(equipmentAction.loadRecords(searchFilter))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }
  //table data

  let slNo = 0
  const equipmentTable = !isEmpty(records)
    ? records.map((equipment) => {
        slNo = slNo + 1

        return {
          sNo: slNo,
          _id: equipment._id,
          asstNumber: equipment.asstNumber,
          attachment: equipment.attachment,
          createdAt: equipment.createdAt,
          dateOfEntry: equipment.dateOfEntry,
          dateOfPurchase: equipment.dateOfPurchase,
          equipmentId: equipment._id,
          serialNumber: equipment.serialNumber,
          equipmentCode: equipment.equipmentCode,
          equipmentMode: equipment.mode,
          // equipments: equipment.equipments,
          BrandName: equipment.equipmentBrandName,
          EquipmentType: equipment.equipmentTypeName,
          ProductVersion: equipment.productVersionName,
        }
      })
    : []
  // add more bank details data

  let [selectedRows, setSelectedRows] = useState([])
  const [rowSelected, setRowSelected] = useState(false)

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      selectedRows.push(row)
      setRowSelected(true)
    } else {
      if (rowUnSelected === true) {
        selectedRows = selectedRows.filter((_) => _._id !== row._id)
        setRowSelected(false)
      } else {
        selectedRows = selectedRows.filter((_) => _._id !== row._id)
        setRowSelected(false)
      }
    }
    setSelectedRows(selectedRows)
    console.log(selectedRows, "selected rows")
    return true
  }

  const handleOnSelectAll = (isSelect, rows) => {
    var ar = []
    if (isSelect) {
      ar = rows
      setRowSelected(true)
    } else {
      if (rowUnSelected === true) {
        ar = []
        setSelectedRows([])
        setRowSelected(false)
      } else {
        ar = []
        setSelectedRows([])
        setRowSelected(false)
      }
    }

    setSelectedRows(ar)
    return true
  }
  const selectRow = {
    mode: "checkbox",
    clickToSelect: false,
    clickToEdit: false,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
    selected: selectedRows.map((_) => _._id),
  }

  console.log(rowSelected, "row selected")
  console.log(selectRow, "row selected")
  //table columns
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    // {
    //   dataField: "action",
    //   text: "Action",
    //   csvExport: false,
    // },
    {
      dataField: "equipmentMode",
      text: "Equipment Mode",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "equipmentCode",
      text: "Equipment Code",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },

    {
      dataField: "EquipmentType",
      text: "Equipment Type",

      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "BrandName",
      text: "Brand Name",
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "ProductVersion",
      text: "Product Version",
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "serialNumber",
      text: "Serial Number",
      headerStyle: {
        minWidth: "170px",
      },
    },
  ]

  const options = {
    sizePerPage: 10,
    totalSize: records.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  const [bankdetails, setBankdetails] = useState([
    {
      equipmentId: "",
      equipment: "",
      equipmentCode: "",
      serialNo: "",
    },
  ])

  const [renderPage, setRenderPage] = useState(false)
  const [rowUnSelected, setRowUnSelected] = useState(false)

  const addBankdetails = async () => {
    setBankdetails([
      ...bankdetails,
      { equipmentId: "", equipment: "", serialNo: "", equipmentCode: "" },
    ])
    setRenderPage(!renderPage)
  }
  console.log(bankdetails, "bankdetails")
  const modalChange = async (e, index, name) => {
    var bankdataList = bankdetails
    // if (name == "serialNo") {
    //   e = e.target.value
    //   bankdataList[index][name] = e
    //   setBankdetails(bankdataList)
    // }
    if (name == "equipmentId") {
      bankdataList[index]["equipmentId"] = e.value
      bankdataList[index]["serialNo"] = e.label
      setBankdetails(bankdataList)
    }

    setRenderPage(!renderPage)
  }

  const [equipmentdata, setEquipmentdata] = useState({
    equipmentId: "",
    equipmentCode: "",
    company: [],
    branch: [],
  })
  const removeMappingdetails = async (toRemove) => {
    var bankdataList = bankdetails
    if (toRemove != 0) {
      if (toRemove > -1) {
        bankdataList.splice(toRemove, 1)
      }
      setBankdetails(bankdataList)
      setRenderPage(!renderPage)
    }
  }

  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [pageLoad, setPageLoad] = useState(false)

  const changeEquipments = (e) => {
    setCompanies(e)
    setBranches([])
  }

  const companyId = companies.value
  const branchId = branches.value
  console.log(companyId, branchId, "company and branch Id")
  // if (branches.value) {
  //   // useEffect(() => {
  //     dispatch(equipmentAction.loadEquipmentMaster(companyId, branchId))
  //   // })
  // }

  const branchOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter(
      (branch) => branch.companyId === companies.value
    )
  console.log("branches", branchOptions)
  console.log("equipment_master", equipment_master)

  //add equipment data

  const bankdetailsData =
    !isEmpty(bankdetails) && bankdetails.length > 0
      ? bankdetails.map((data) => {
          if (data) {
            return data.equipmentId
            // quanity: data.equipmentCode,
            // serialNo: data.serialNo,
            // equipmentCode: data.equipmentCode,
          }
        })
      : []

  // add equipment

  const addEquipment = () => {
    const formValid = simpleValidator.current.allValid()
    if (!formValid) {
      simpleValidator.current.showMessages()
      forceUpdate(1)
    } else {
      const record = {
        companyId: companies.value,
        branchId: branches.value,
        equipmentId: bankdetailsData,
      }
      console.log(record, "add data is")

      dispatch(equipmentAction.createRecord(record))
      setRowUnSelected(true)
      setRowSelected(false)
      setPageLoad(!pageLoad)
      setTimeout(() => {
        clearData()
        dispatch(equipmentAction.loadRecords())
        setEquipmentModal(false)
        // setBankdetails([])
        toast.success("Equipment Mapped Successfully")
        setBankdetails([
          ...bankdetails,
          { equipmentId: "", equipment: "", serialNo: "", equipmentCode: "" },
        ])
      }, 2000)
    }
  }

  const selectedData = !isEmpty(selectedRows)
    ? selectedRows.map((row) => row)
    : []
  console.log(selectedData, "selectedData")
  //Edit Equipment
  const editEquipment = (equipment) => {
    console.log(equipment, "equipment data")

    setCompanies({ label: equipment.companyName, value: equipment.companyId })
    setBranches({ label: equipment.branchName, value: equipment.branchId })
    // setEquipmentdata({ equipmentId: equipment._id, equipmentCode: equipment.equipmentCode  })
    setEquipmentdata({ equipmentId: equipment._id })

    // var equipmentdetailsEdit = equipment
    // console.log(equipmentdetailsEdit, "equipmentdetailsEdit")
    const equipmentEditUpdated = !isEmpty(equipment)
      ? equipment.map((data) => {
          // console.log(data.equipmentCode, "equipment code")
          return {
            equipmentId: data.equipmentId,
            // equipment: get(data, "equipmentCode", ""),
            // equipmentCode: get(data, "equipmentCode", ""),
            serialNo: data.serialNumber,
          }
        })
      : []
    // setBankdetails([...bankdetails, equipmentEditUpdated])
    setBankdetails(equipmentEditUpdated)

    // setBankdetails(equipmentEditUpdated)
    setPageLoad(!pageLoad)
  }

  //Update Equipment
  const updateEquipmentbyId = () => {
    const formValid = simpleValidator.current.allValid()
    if (!formValid) {
      simpleValidator.current.showMessages()
      forceUpdate(1)
    } else {
      const record = {
        equipmentId: equipmentdata.equipmentId,
        companyId: companies.value,
        branchId: branches.value,
        equipment: bankdetailsData,
      }
      console.log(record, "add data is")
    }
  }

  console.log(updateEquipmentbyId, "updateEquipmentbyId")

  //Clear data's
  const clearData = () => {
    setCompanies([])
    setBranches([])
    setBankdetails([
      { ...bankdetails, equipmentId: "", equipment: "", serialNo: "" },
    ])
  }

  //Delete section

  // const editdeleteModal = (equipment) => {
  //   setEquipmentdata({ ...equipmentdata, _id: equipment._id })
  // }

  // const deleteEquipment = () => {
  //   const deleteData = {
  //     equipmentId: [equipmentdata._id],
  //     status: 3,
  //   }
  //   console.log(deleteData, "deleted")
  //   dispatch(equipmentAction.deleteRecord(deleteData))
  //   setTimeout(() => {
  //     dispatch(equipmentAction.loadRecords())
  //   }, 1000)
  // }

  const resetFormDetails = () => {
    setEquipmentBrand([])
    setEquipmentMaster([])
    setEquipmentProduct([])
    setEquipmentType([])
    dispatch(equipmentAction.loadRecords())
  }

  const modeOptions = [
    {
      label: "ADMIN",
      value: "ADMIN",
    },
    {
      label: "HR",
      value: "HR",
    },
    {
      label: "PHOTOGRAPHY",
      value: "PHOTOGRAPHY",
    },
    {
      label: "IT",
      value: "IT",
    },
    {
      label: "VERMILION",
      value: "VERMILION",
    },
    {
      label: "DIVINE",
      value: "DIVINE",
    },
    {
      label: "ZG OPERATIONS",
      value: "ZG OPERATIONS",
    }
  ]
  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={"Master"} breadcrumbItem={title} />
        <Row>
          <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
            <div className="filter-buttons" style={{ float: "right" }}>
              <Button
                style={{
                  backgroundColor: "#E40D8C",
                  color: "white",
                  border: "none",
                  marginTop: "-35px",
                }}
                onClick={() => {
                  setEquipmentModal(true)
                  setFullscreen(true)
                  setEditEquipment(false)
                  clearData()
                }}
              >
                Add Mapping
              </Button>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"Mode"}
                        </Label>
                      </div>
                      <Select
                        name="equipmentMaster"
                        value={equipmentMaster}
                        onChange={(e) => setEquipmentMaster(e)}
                        options={modeOptions}
                        placeholder="Select Mode"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"Equipment Type"}
                        </Label>
                      </div>
                      <Select
                        name="equipmentType"
                        value={equipmentType}
                        onChange={(e) => setEquipmentType(e)}
                        options={
                          recordsMetaData ? recordsMetaData.typeOptions : []
                        }
                        placeholder="Select Equipment"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"Equipment Brand"}
                        </Label>
                      </div>
                      <Select
                        name="equipmentBrand"
                        value={equipmentBrand}
                        onChange={(e) => setEquipmentBrand(e)}
                        options={
                          recordsMetaData ? recordsMetaData.brandOptions : []
                        }
                        placeholder="Select Equipment Brand"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"Product Version"}
                        </Label>
                      </div>
                      <Select
                        name="equipmentProduct"
                        value={equipmentProduct}
                        onChange={(e) => setEquipmentProduct(e)}
                        options={
                          recordsMetaData ? recordsMetaData.productOptions : []
                        }
                        placeholder="Select Product Version"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                          onClick={() => resetFormDetails()}
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="button"
                          onClick={() => handleApply()}
                          className="btn btn-success btn-label simple-form-applyfilter-btn"
                        >
                          <i className="bx bx-filter-alt label-icon"></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md="12" lg="12" xl="12">
            <Card>
              <CardBody>
                <PaginationProvider
                  pagination={paginationFactory(options)}
                  keyField="_id"
                  columns={columns}
                >
                  {({ paginationProps, paginationTableProps }) => (
                    <ToolkitProvider
                      keyField="_id"
                      data={equipmentTable}
                      columns={columns}
                      search
                      // selectRow={selectRow}
                    >
                      {(props) => (
                        <div>
                          <Col md="12" xl="12" lg="12" sm="12" xs="12">
                            <Row className="d-flex flex-row">
                              <Col className="mb-3" md="4">
                                <div className="d-flex flex-row ">
                                  <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                    <div
                                      className="position-relative mt-7"
                                      style={searchBtnStyle || null}
                                    >
                                      <SearchBar {...props.searchProps} />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </div>{" "}
                              </Col>
                              <Col>
                                <ExportCSVButton
                                  className="border float-right mx-10"
                                  style={{
                                    float: "right",
                                    backgroundColor: "#e40d8c",
                                    color: "#ffffff",
                                  }}
                                  {...props.csvProps}
                                >
                                  Download{" "}
                                </ExportCSVButton>{" "}
                              </Col>
                              <Col>
                                <BootstrapTable
                                  keyField={"_id"}
                                  {...props.baseProps}
                                  responsive
                                  striped={true}
                                  bordered={true}
                                  selectRow={selectRow}
                                  {...paginationTableProps}
                                />
                              </Col>
                            </Row>
                            <Row
                              style={{ marginTop: "5px" }}
                              className="align-items-md-center mt-30"
                            >
                              <Col className="inner-custom-pagination d-flex">
                                <div className="d-inline d-flex flex-row">
                                  <SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  />
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      marginTop: "8px",
                                      marginLeft: "4px",
                                    }}
                                  >
                                    <PaginationTotalStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="text-md-right ms-auto"
                                  style={{ zIndex: 0 }}
                                >
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </div>
                      )}
                    </ToolkitProvider>
                  )}
                </PaginationProvider>
                {rowSelected ? (
                  <>
                    <Button
                      className="btn btn-success"
                      onClick={() => {
                        editEquipment(selectedRows)
                        setEditEquipment(true)
                        setEquipmentModal(true)
                        setFullscreen(true)
                      }}
                    >
                      Mapping
                    </Button>
                  </>
                ) : (
                  ""
                )}
              </CardBody>
            </Card>
            {equipmentModal && (
              <Modal
                show={equipmentModal}
                onHide={handleModal}
                fullscreen={fullscreen}
              >
                <Modal.Header
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  <Col xl="12" md="12" lg="12" sm="12" xs="12">
                    <div className="sales-modal-header">
                      <h4
                        className="modal-title mt-0 sales-modal-title"
                        id="myModalLabel"
                        //style={{color:"#E40D8C"}}
                      >
                        {editequipment ? "EDIT EQUIPMENT" : "ADD EQUIPMENT"}
                      </h4>
                      <span>
                        <i
                          className="fa fa-times quote-close"
                          aria-hidden="true"
                          onClick={() => setEquipmentModal(false)}
                        ></i>
                      </span>
                    </div>
                  </Col>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Card
                      style={{
                        backgroundColor: "rgba(211,211,211,0.13)",
                        padding: "15px,15px,0px",
                        border: "2px solid rgb(239, 242, 247)",
                        boxShadow: "none",
                      }}
                    >
                      <CardBody>
                        <Row>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className={"form-label"}
                                htmlFor={"Company Name"}
                              >
                                {"Company Name"}
                                <span className="required mx-1">*</span>
                              </Label>
                            </div>

                            <Select
                              type="text"
                              name="companies"
                              value={companies}
                              onChange={(e) => changeEquipments(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.companyOptions
                                  : []
                              }
                              placeholder="Select Company Name"
                              classNamePrefix="select2-selection"
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "Company Name",
                                companies,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className={"form-label"}
                                htmlFor={"Branch Name"}
                              >
                                {"Branch Name"}
                                <span className="required mx-1">*</span>
                              </Label>
                            </div>

                            <Select
                              type="text"
                              name="branches"
                              value={branches}
                              onChange={(e) => setBranches(e)}
                              options={branchOptions}
                              disabled={"disabled"}
                              placeholder="Select Branch Name"
                              classNamePrefix="select2-selection"
                            />

                            <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "Branch Name",
                                branches,
                                "required"
                              )}
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Row>
                  <Row>
                    <Card
                      style={{
                        backgroundColor: "rgba(211,211,211,0.13)",
                        padding: "15px,15px,0px",
                        border: "2px solid rgb(239, 242, 247)",
                        boxShadow: "none",
                      }}
                    >
                      <CardBody>
                        <Row className="mt-3">
                          <Col lg="9" md="9" sm="12">
                            <p
                              style={{
                                //color: "#4486eb",
                                margin: "0px",
                                marginRight: "15px",
                                marginTop: "15px",
                                fontSize: "16px",
                                fontWeight: "500",
                              }}
                            >
                              Equipment Details
                            </p>
                          </Col>
                          <Col lg="3" md="3" sm="12">
                            <Button
                              style={{
                                backgroundColor: "#4486eb",
                                border: "none",
                                marginTop: "20px",
                                float: "right",
                              }}
                              onClick={() => {
                                addBankdetails()
                              }}
                            >
                              Add More
                            </Button>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="12" md="12" sm="12" className="mt-3">
                            <Table bordered>
                              <thead>
                                <tr>
                                  <th
                                    style={{
                                      width: "20%",
                                      textAlign: "center",
                                      backgroundColor: "white",
                                    }}
                                  >
                                    Equipment
                                  </th>
                                  <th
                                    style={{
                                      width: "20%",
                                      textAlign: "center",
                                      backgroundColor: "white",
                                    }}
                                  >
                                    Equipment Code{" "}
                                  </th>
                                  <th
                                    style={{
                                      width: "20%",
                                      textAlign: "center",
                                      backgroundColor: "white",
                                    }}
                                  >
                                    Equipment Type{" "}
                                  </th>
                                  <th
                                    style={{
                                      width: "20%",
                                      textAlign: "center",
                                      backgroundColor: "white",
                                    }}
                                  >
                                    Brand Name
                                  </th>
                                  <th
                                    style={{
                                      width: "20%",
                                      textAlign: "center",
                                      backgroundColor: "white",
                                    }}
                                  >
                                    Product Version
                                  </th>
                                  <th
                                    className="icon-section"
                                    style={{
                                      width: "20%",
                                      textAlign: "center",
                                      backgroundColor: "white",
                                    }}
                                  >
                                    <i className="fa fa-times remove-icon"></i>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {!isEmpty(bankdetails) &&
                                  bankdetails.length > 0 &&
                                  bankdetails.map((item, index) => {
                                    console.log(item, "item data")
                                    const equipmentCodeList =
                                      !isEmpty(recordsMetaData) &&
                                      recordsMetaData.equipmentMasterOptions &&
                                      recordsMetaData.equipmentMasterOptions
                                        .length > 0
                                        ? recordsMetaData.equipmentMasterOptions.find(
                                            (_) => _.value === item.equipmentId
                                          )
                                        : ""
                                    const equipmentTypeList =
                                      !isEmpty(recordsMetaData) &&
                                      recordsMetaData.equipmentTypeOptions &&
                                      recordsMetaData.equipmentTypeOptions
                                        .length > 0
                                        ? recordsMetaData.equipmentTypeOptions.find(
                                            (_) => _.value === item.equipmentId
                                          )
                                        : ""
                                    const equipmentBrandList =
                                      !isEmpty(recordsMetaData) &&
                                      recordsMetaData.brandEquipmentOptions &&
                                      recordsMetaData.brandEquipmentOptions
                                        .length > 0
                                        ? recordsMetaData.brandEquipmentOptions.find(
                                            (_) => _.value === item.equipmentId
                                          )
                                        : ""
                                    const equipmentProductList =
                                      !isEmpty(recordsMetaData) &&
                                      recordsMetaData.equipmentProductOptions &&
                                      recordsMetaData.equipmentProductOptions
                                        .length > 0
                                        ? recordsMetaData.equipmentProductOptions.find(
                                            (_) => _.value === item.equipmentId
                                          )
                                        : ""
                                    console.log(
                                      equipmentCodeList,
                                      "equipmentCodeList"
                                    )
                                    console.log(
                                      equipmentTypeList,
                                      "equipmentTypeList"
                                    )
                                    console.log(
                                      equipmentBrandList,
                                      "equipmentBrandList"
                                    )
                                    console.log(
                                      equipmentProductList,
                                      "equipmentProductList"
                                    )
                                    return (
                                      <>
                                        <tr className="bg-white" key={index}>
                                          <td>
                                            <Select
                                              name="equipmentId"
                                              value={
                                                item.equipmentId
                                                  ? {
                                                      value: item.equipmentId,
                                                      label: item.serialNo,
                                                    }
                                                  : ""
                                              }
                                              onChange={(e) =>
                                                modalChange(
                                                  e,
                                                  index,
                                                  "equipmentId"
                                                )
                                              }
                                              options={
                                                recordsMetaData
                                                  ? recordsMetaData.equipmentMasterOptions
                                                  : []
                                              }
                                              placeholder="Select Equipment"
                                              classNamePrefix="select2-selection"
                                            />
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {!isEmpty(item.equipmentId) &&
                                            !isEmpty(
                                              equipmentCodeList.equipmentCode
                                            ) &&
                                            equipmentCodeList.equipmentCode !==
                                              undefined
                                              ? equipmentCodeList.equipmentCode
                                              : ""}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {!isEmpty(item.equipmentId) &&
                                            !isEmpty(
                                              equipmentBrandList.label
                                            ) &&
                                            equipmentBrandList.label !==
                                              undefined
                                              ? equipmentBrandList.label
                                              : ""}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {!isEmpty(item.equipmentId) &&
                                            !isEmpty(equipmentTypeList.label) &&
                                            equipmentTypeList.label !==
                                              undefined
                                              ? equipmentTypeList.label
                                              : ""}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {!isEmpty(item.equipmentId) &&
                                            !isEmpty(
                                              equipmentProductList.label
                                            ) &&
                                            equipmentProductList.label !==
                                              undefined
                                              ? equipmentProductList.label
                                              : ""}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            <i
                                              className="fa fa-times remove-icon"
                                              onClick={() =>
                                                removeMappingdetails(index)
                                              }
                                            ></i>
                                          </td>
                                        </tr>
                                      </>
                                    )
                                  })}
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Col>
                    <div style={{ float: "right" }}>
                      <Button
                        variant="secondary"
                        className="btn btn-danger"
                        onClick={() => {
                          setRowUnSelected(true)
                          setRowSelected(false)
                          setEquipmentModal(false)
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        style={{ marginLeft: "20px" }}
                        variant="primary"
                        className="btn btn-success"
                        onClick={() => {
                          addEquipment()
                        }}
                      >
                        Submit
                      </Button>
                    </div>
                  </Col>
                </Modal.Footer>
              </Modal>
            )}
          </Col>
        </Row>
        {/* {deletemodal && (
          <Modal
            show={deletemodal}
            size="md"
            style={{ backgroundColor: "#504e4ec9", opacity: 0.98 }}
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Do You Want To Delete this record?
            </Modal.Header>
            <Modal.Footer>
              <div>
                <Button
                  type="submit"
                  onClick={() => {
                    setDeletemodal(false)
                  }}
                  style={{ fontSize: "10px", marginLeft: "20px" }}
                  className="btn btn-danger buttons"
                >
                  {" "}
                  Cancel
                </Button>
                <Button
                  type="submit"
                  onClick={() => {
                    deleteEquipment()
                    setTimeout(() => {
                      setDeletemodal(false)
                    }, 1000)
                  }}
                  style={{ fontSize: "10px", marginLeft: "20px" }}
                  className="btn btn-success buttons"
                >
                  {" "}
                  Confirm
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )} */}
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Container>
    </div>
  )
}
EquipmentMapping.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  disableMultiSelect: PropTypes.any,
  csvProps: PropTypes.any,
  //isInvalid:PropTypes.any
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EquipmentMapping)
)
